import { gql } from "@apollo/client";
export const GET_HOLIDAY = gql`
  query GetHoliday($department: String!, $role: String!) {
    GetHoliday(department: $department,role:$role) {
      _id
      name
      department
      date
      type
    }
  }
`;
export const CREATE_HOLIDAY = gql`
mutation CreateHoliday($name: String, $department: String, $date: String,$type: String) {
  CreateHoliday(name: $name, department: $department, date: $date, type: $type) {
  status
  message
  holidays{
    name
    department
    date
    type
  }
}
}
`;
export const DELETE_HOLIDAY = gql`
mutation DeleteHoliday($id: String!) {
  DeleteHoliday(id: $id) {
    name
  }
}`;
export const UPDATE_HOLIDAY = gql`
  mutation UpdateHoliday($id: String, $name: String, $department: String, $date: String,$type: String) {
    UpdateHoliday(id: $id, name: $name, department: $department, date: $date, type: $type) {
    status
    message
    holidays{
      _id
      name
      department
      date
      type
    }
  } 
}
`;
